import React from 'react';
import { useSelector } from 'react-redux';
import "./style.scss";
import { settings } from "../../settings";
import translations from "../Common/translations.json";


export const UnsubscribePage = () => {
    const translation = translations[settings.lang];
    const subscription = useSelector((state) => state.mainPage.subscription);
    const newsEventSubscription = useSelector((state) => state.newsEventPage.subscription);
    const newsEventListing = useSelector((state) => state.newsEventPage.listing);

    // This page is shared by both unsubscribe flows, so fall back to the news
    // event subscription when the visitor did not come from the index page.
    const emailCompanyName = subscription.language.toUpperCase() === "ENGLISH" ? subscription.companyNames.ENGLISH : subscription.companyNames.ARABIC;
    const newsEventCompanyName = settings.lang === "ar" && newsEventListing.name_ar
        ? newsEventListing.name_ar
        : newsEventSubscription.companyName;
    const companyName = emailCompanyName || newsEventCompanyName;

    return (
        <div className="unsubscribepage-wrapper">
            <div className="unsubscribepage-company-title-block">
                <span className="unsubscribepage-company-title">
                    {companyName}       
                </span>
            </div>
            <div className="unsubscribepage-detail-wrapper">
                <div className="subscription-detail-block-top">
                    <span className="subscription-detail-title">
                        {translation.modalStrings.youWereSuccessfullyUnsubscribed}
                    </span>
                </div>
                <div className="subscription-detail-block-bottom">
                    <span className="subscription-detail-title">
                        {translation.modalStrings.ifYouWouldLikeToResubscribe}
                    </span>
                </div>
            </div>
        </div>
    )
}
